var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "departments-page", attrs: { id: "subjects" } },
    [
      _c(
        "div",
        { staticClass: "departments-header" },
        [
          _c("a-input-search", {
            staticClass: "search-input departments-search",
            attrs: { placeholder: _vm.$t("message.search") },
            on: { search: _vm.onSearch },
            model: {
              value: _vm.searchText,
              callback: function ($$v) {
                _vm.searchText = $$v
              },
              expression: "searchText",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "departments-header__right" },
            [
              _c(
                "SupsisButton",
                {
                  attrs: { small: "", ghost: "" },
                  on: { click: _vm.collapseAll },
                },
                [
                  _c("md-icon", [_vm._v("unfold_less")]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.collapseAll")) +
                      "\n            "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "SupsisButton",
                {
                  attrs: { small: "", ghost: "" },
                  on: { click: _vm.expandAll },
                },
                [
                  _c("md-icon", [_vm._v("unfold_more")]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.expandAll")) +
                      "\n            "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "SupsisButton",
                {
                  attrs: { ghost: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$feature.beforeCreateDepartment(
                        _vm.showModalWithoutEdit,
                        _vm.paginationCursor.total
                      )
                    },
                  },
                },
                [
                  _c("md-icon", [_vm._v("add")]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.createDepartment")) +
                      "\n            "
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "department-groups" },
        _vm._l(_vm.departmentGroups, function (usersInGroup, groupKey) {
          return _c(
            "div",
            {
              key: groupKey,
              staticClass: "department-card",
              class: {
                "department-card--no-dept": groupKey === _vm.noDepartmentKey,
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "department-card__header",
                  style:
                    groupKey !== _vm.noDepartmentKey
                      ? { borderLeftColor: _vm.getGroupColor(groupKey) }
                      : {},
                  on: {
                    click: function ($event) {
                      return _vm.toggleGroup(groupKey)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "department-card__title-row" },
                    [
                      _c(
                        "md-icon",
                        { staticClass: "department-card__toggle" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.expandedGroups.has(groupKey)
                                ? "expand_more"
                                : "chevron_right"
                            )
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "department-card__name" }, [
                        _vm._v(_vm._s(_vm.getGroupDisplayName(groupKey))),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "department-card__count" }, [
                        _vm._v(_vm._s(usersInGroup.length)),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "department-card__actions",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      groupKey !== _vm.noDepartmentKey &&
                      _vm.getSubjectByKey(groupKey)
                        ? [
                            _vm.checkPermission(
                              _vm.PERMISSION_TYPES["topic.update"].tr.name
                            )
                              ? _c(
                                  "a-button",
                                  {
                                    staticClass: "action-btn",
                                    attrs: { type: "link", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        _vm.edit(
                                          _vm.getSubjectByKey(groupKey)._id
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "material-icons" },
                                      [_vm._v("edit")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.checkPermission(
                              _vm.PERMISSION_TYPES["topic.delete"].tr.name
                            )
                              ? _c(
                                  "a-button",
                                  {
                                    staticClass:
                                      "action-btn action-btn--danger",
                                    attrs: { type: "link", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        _vm.remove(
                                          _vm.getSubjectByKey(groupKey)._id
                                        )
                                      },
                                    },
                                  },
                                  [_c("ActionDelete")],
                                  1
                                )
                              : _vm._e(),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.expandedGroups.has(groupKey),
                      expression: "expandedGroups.has(groupKey)",
                    },
                  ],
                  staticClass: "department-card__body",
                },
                [
                  _vm.canUpdateUser
                    ? _c(
                        "div",
                        { staticClass: "department-card__user-actions" },
                        [
                          groupKey !== _vm.noDepartmentKey
                            ? _c(
                                "SupsisButton",
                                {
                                  attrs: { xsmall: "", ghost: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openAddUsersModal(groupKey)
                                    },
                                  },
                                },
                                [
                                  _c("md-icon", [_vm._v("person_add")]),
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$t("message.addUsersToDepartment")
                                      ) +
                                      "\n                    "
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          usersInGroup.length > 0 &&
                          !_vm.isAllSelectedInGroup(groupKey)
                            ? _c(
                                "SupsisButton",
                                {
                                  attrs: { xsmall: "", ghost: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectAllInGroup(groupKey)
                                    },
                                  },
                                },
                                [
                                  _c("md-icon", [_vm._v("select_all")]),
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$t("message.selectAll")) +
                                      "\n                    "
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectedUserIdsInGroup(groupKey).length > 0
                            ? _c(
                                "SupsisButton",
                                {
                                  attrs: { xsmall: "", ghost: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.deselectAllInGroup(groupKey)
                                    },
                                  },
                                },
                                [
                                  _c("md-icon", [_vm._v("deselect")]),
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$t("message.deselectAll")) +
                                      "\n                    "
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          groupKey !== _vm.noDepartmentKey &&
                          _vm.selectedUserIdsInGroup(groupKey).length > 0
                            ? _c(
                                "SupsisButton",
                                {
                                  attrs: { xsmall: "", ghost: "", danger: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.confirmRemoveFromDepartment(
                                        groupKey
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("md-icon", [_vm._v("person_remove")]),
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$t("message.removeFromDepartment")
                                      ) +
                                      " (" +
                                      _vm._s(
                                        _vm.selectedUserIdsInGroup(groupKey)
                                          .length
                                      ) +
                                      ")\n                    "
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          groupKey !== _vm.noDepartmentKey &&
                          _vm.selectedUserIdsInGroup(groupKey).length > 0
                            ? _c(
                                "a-dropdown",
                                { attrs: { trigger: ["click"] } },
                                [
                                  _c(
                                    "SupsisButton",
                                    { attrs: { xsmall: "", ghost: "" } },
                                    [
                                      _c("md-icon", [
                                        _vm._v("drive_file_move"),
                                      ]),
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.$t("message.moveToDepartment")
                                          ) +
                                          " (" +
                                          _vm._s(
                                            _vm.selectedUserIdsInGroup(groupKey)
                                              .length
                                          ) +
                                          ")\n                        "
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-menu",
                                    {
                                      attrs: { slot: "overlay" },
                                      on: {
                                        click: function (ref) {
                                          var key = ref.key

                                          return _vm.moveUsersDirectly(
                                            groupKey,
                                            key
                                          )
                                        },
                                      },
                                      slot: "overlay",
                                    },
                                    [
                                      _c("a-menu-item", { key: "__all__" }, [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.moveToAllDepartments"
                                              )
                                            ) +
                                            "\n                            "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("a-menu-divider"),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.getOtherSubjects(groupKey),
                                        function (s) {
                                          return _c(
                                            "a-menu-item",
                                            { key: s._id },
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.getSubjectName(s)
                                                  ) +
                                                  "\n                            "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          groupKey !== _vm.noDepartmentKey &&
                          _vm.selectedUserIdsInGroup(groupKey).length > 0
                            ? _c(
                                "a-dropdown",
                                { attrs: { trigger: ["click"] } },
                                [
                                  _c(
                                    "SupsisButton",
                                    { attrs: { xsmall: "", ghost: "" } },
                                    [
                                      _c("md-icon", [_vm._v("content_copy")]),
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.$t("message.copyToDepartment")
                                          ) +
                                          " (" +
                                          _vm._s(
                                            _vm.selectedUserIdsInGroup(groupKey)
                                              .length
                                          ) +
                                          ")\n                        "
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-menu",
                                    {
                                      attrs: { slot: "overlay" },
                                      on: {
                                        click: function (ref) {
                                          var key = ref.key

                                          return _vm.copyUsersToDepartment(
                                            groupKey,
                                            key
                                          )
                                        },
                                      },
                                      slot: "overlay",
                                    },
                                    [
                                      _c("a-menu-item", { key: "__all__" }, [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.copyToAllDepartments"
                                              )
                                            ) +
                                            "\n                            "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("a-menu-divider"),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.getOtherSubjects(groupKey),
                                        function (s) {
                                          return _c(
                                            "a-menu-item",
                                            { key: s._id },
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.getSubjectName(s)
                                                  ) +
                                                  "\n                            "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          groupKey === _vm.noDepartmentKey &&
                          _vm.selectedUserIdsInGroup(groupKey).length > 0
                            ? _c(
                                "a-dropdown",
                                { attrs: { trigger: ["click"] } },
                                [
                                  _c(
                                    "SupsisButton",
                                    { attrs: { xsmall: "", ghost: "" } },
                                    [
                                      _c("md-icon", [
                                        _vm._v("drive_file_move"),
                                      ]),
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.$t("message.moveToDepartment")
                                          ) +
                                          " (" +
                                          _vm._s(
                                            _vm.selectedUserIdsInGroup(groupKey)
                                              .length
                                          ) +
                                          ")\n                        "
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-menu",
                                    {
                                      attrs: { slot: "overlay" },
                                      on: {
                                        click: function (ref) {
                                          var key = ref.key

                                          return _vm.assignUsersToDepartment(
                                            groupKey,
                                            key
                                          )
                                        },
                                      },
                                      slot: "overlay",
                                    },
                                    _vm._l(_vm.undeleted, function (s) {
                                      return _c("a-menu-item", { key: s._id }, [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(_vm.getSubjectName(s)) +
                                            "\n                            "
                                        ),
                                      ])
                                    }),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "department-card__user-list" },
                    [
                      _vm._l(usersInGroup, function (user) {
                        return _c(
                          "div",
                          {
                            key: user._id,
                            staticClass: "department-user-item",
                            class: {
                              selected: _vm.isUserSelectedForAction(user._id),
                            },
                          },
                          [
                            _vm.canUpdateUser
                              ? _c("a-checkbox", {
                                  attrs: {
                                    checked: _vm.isUserSelectedForAction(
                                      user._id
                                    ),
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.toggleUserSelection(user._id)
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("AgentAvatar", {
                              attrs: {
                                userID: user._id,
                                size: 32,
                                isNamed: false,
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "department-user-item__name" },
                              [_vm._v(_vm._s(user.name || user.email))]
                            ),
                            _vm._v(" "),
                            _vm.canUpdateUser &&
                            groupKey !== _vm.noDepartmentKey &&
                            _vm.getSubjectByKey(groupKey)
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "department-user-item__actions",
                                  },
                                  [
                                    _c(
                                      "a-dropdown",
                                      { attrs: { trigger: ["click"] } },
                                      [
                                        _c(
                                          "a-button",
                                          {
                                            attrs: {
                                              type: "link",
                                              size: "small",
                                            },
                                          },
                                          [
                                            _c("md-icon", [
                                              _vm._v("more_vert"),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-menu",
                                          {
                                            attrs: { slot: "overlay" },
                                            slot: "overlay",
                                          },
                                          [
                                            _c(
                                              "a-menu-item",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.removeUserFromDepartment(
                                                      user,
                                                      groupKey
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("md-icon", [
                                                  _vm._v("person_remove"),
                                                ]),
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.removeFromDepartment"
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a-sub-menu",
                                              {
                                                attrs: {
                                                  title: _vm.$t(
                                                    "message.moveToDepartment"
                                                  ),
                                                },
                                              },
                                              [
                                                _c(
                                                  "a-menu-item",
                                                  {
                                                    key: "move-all",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.moveSingleUser(
                                                          user,
                                                          groupKey,
                                                          "__all__"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.moveToAllDepartments"
                                                          )
                                                        ) +
                                                        "\n                                        "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("a-menu-divider"),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.getOtherSubjects(
                                                    groupKey
                                                  ),
                                                  function (s) {
                                                    return _c(
                                                      "a-menu-item",
                                                      {
                                                        key: "move-" + s._id,
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.moveSingleUser(
                                                              user,
                                                              groupKey,
                                                              s._id
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(
                                                              _vm.getSubjectName(
                                                                s
                                                              )
                                                            ) +
                                                            "\n                                        "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a-sub-menu",
                                              {
                                                attrs: {
                                                  title: _vm.$t(
                                                    "message.copyToDepartment"
                                                  ),
                                                },
                                              },
                                              _vm._l(
                                                _vm.getOtherSubjects(groupKey),
                                                function (s) {
                                                  return _c(
                                                    "a-menu-item",
                                                    {
                                                      key: "copy-" + s._id,
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.copySingleUserToDepartment(
                                                            user,
                                                            s._id
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            _vm.getSubjectName(
                                                              s
                                                            )
                                                          ) +
                                                          "\n                                        "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.canUpdateUser &&
                            groupKey === _vm.noDepartmentKey
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "department-user-item__actions",
                                  },
                                  [
                                    _c(
                                      "a-dropdown",
                                      { attrs: { trigger: ["click"] } },
                                      [
                                        _c(
                                          "a-button",
                                          {
                                            attrs: {
                                              type: "link",
                                              size: "small",
                                            },
                                          },
                                          [
                                            _c("md-icon", [
                                              _vm._v("more_vert"),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-menu",
                                          {
                                            attrs: { slot: "overlay" },
                                            slot: "overlay",
                                          },
                                          [
                                            _c(
                                              "a-sub-menu",
                                              {
                                                attrs: {
                                                  title: _vm.$t(
                                                    "message.moveToDepartment"
                                                  ),
                                                },
                                              },
                                              _vm._l(
                                                _vm.undeleted,
                                                function (s) {
                                                  return _c(
                                                    "a-menu-item",
                                                    {
                                                      key: "move-nd-" + s._id,
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.assignSingleUserToDepartment(
                                                            user,
                                                            s._id
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            _vm.getSubjectName(
                                                              s
                                                            )
                                                          ) +
                                                          "\n                                        "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      usersInGroup.length === 0
                        ? _c("div", { staticClass: "department-card__empty" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.noUsersInDepartment")) +
                                "\n                    "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.isModalShow
        ? _c(
            "a-modal",
            {
              attrs: {
                visible: _vm.isModalShow,
                title: _vm.editMode
                  ? _vm.$t("message.updateDepartmentForm")
                  : _vm.$t("message.newDepartmentForm"),
                footer: null,
                width: 600,
                wrapClassName: "subject-form-modal",
              },
              on: { cancel: _vm.hideModal },
            },
            [
              _c(
                "div",
                { attrs: { id: "modal-inner" } },
                [
                  _vm.$validator.errors.items.length && _vm.submitClicked
                    ? _c(
                        "a-alert",
                        {
                          key: "alertContainer-" + _vm.$i18n.locale,
                          staticClass: "mb-2",
                          attrs: {
                            message: _vm.$t("message.error"),
                            showIcon: "",
                            type: "error",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              attrs: { slot: "description" },
                              slot: "description",
                            },
                            _vm._l(
                              _vm.$validator.errors.items,
                              function (err, idx) {
                                return _c("div", { key: idx }, [
                                  _c("span", [_vm._v(_vm._s(err.msg))]),
                                ])
                              }
                            ),
                            0
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    {
                      staticClass: "d-flex flex-column justify-content-center",
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.duplicateControl.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      _c("MultiContent", {
                                        ref: "MultiContent",
                                        model: {
                                          value: _vm.subjectInitialObject,
                                          callback: function ($$v) {
                                            _vm.subjectInitialObject = $$v
                                          },
                                          expression: "subjectInitialObject",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "mt-3",
                                      attrs: { md: "12" },
                                    },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label: _vm.$t("report.status"),
                                          },
                                        },
                                        [
                                          _c(
                                            "b-form-radio-group",
                                            {
                                              attrs: {
                                                name: "status",
                                                required: "",
                                              },
                                              model: {
                                                value: _vm.subject.isActive,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.subject,
                                                    "isActive",
                                                    $$v
                                                  )
                                                },
                                                expression: "subject.isActive",
                                              },
                                            },
                                            [
                                              _c(
                                                "b-form-radio",
                                                { attrs: { value: true } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("message.active")
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-form-radio",
                                                { attrs: { value: false } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("message.passive")
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      _vm.checkPermission(
                                        _vm.PERMISSION_TYPES["topic.update"].tr
                                          .name
                                      )
                                        ? _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                disabled: _vm.loading,
                                                type: "submit",
                                                variant: "primary",
                                              },
                                            },
                                            [
                                              !_vm.loading
                                                ? [
                                                    !_vm.editMode
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.save"
                                                              )
                                                            )
                                                          ),
                                                        ])
                                                      : _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.update"
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                  ]
                                                : [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "spinner",
                                                        spin: "",
                                                      },
                                                    }),
                                                  ],
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        { on: { click: _vm.hideModal } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("message.cancel"))
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("message.addUsersToDepartment"),
            visible: _vm.showAddUsersModal,
            footer: null,
            width: 400,
            wrapClassName: "add-users-modal-wrap",
          },
          on: { cancel: _vm.closeAddUsersModal },
        },
        [
          _c(
            "div",
            { staticClass: "add-users-modal" },
            [
              _c("AgentPicker", {
                ref: "addUsersPicker",
                attrs: { omitItems: _vm.getUserIdsInCurrentGroup() },
                model: {
                  value: _vm.addUsersSelected,
                  callback: function ($$v) {
                    _vm.addUsersSelected = $$v
                  },
                  expression: "addUsersSelected",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "add-users-modal__footer" },
                [
                  _c(
                    "SupsisButton",
                    {
                      attrs: { ghost: "" },
                      on: { click: _vm.closeAddUsersModal },
                    },
                    [_vm._v(_vm._s(_vm.$t("message.cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "SupsisButton",
                    {
                      attrs: { primary: "", disabled: _vm.addUsersLoading },
                      on: { click: _vm.confirmAddUsersToDepartment },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("message.save")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("message.bulkUpdateProgress"),
            visible: _vm.bulkProgress.visible,
            footer: null,
            closable: !_vm.bulkProgress.loading,
            maskClosable: false,
          },
        },
        [
          _c(
            "div",
            { staticClass: "progress-modal" },
            [
              _c("a-progress", {
                attrs: {
                  percent: _vm.bulkProgress.total
                    ? Math.round(
                        (_vm.bulkProgress.current / _vm.bulkProgress.total) *
                          100
                      )
                    : 0,
                  status: "active",
                },
              }),
              _vm._v(" "),
              _c("p", { staticClass: "progress-modal__text" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.bulkProgress.current) +
                    " / " +
                    _vm._s(_vm.bulkProgress.total) +
                    " " +
                    _vm._s(_vm.$t("message.usersUpdated")) +
                    "\n            "
                ),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }